export const getImageSize = (screenSize: boolean | undefined): number => (screenSize ? 72 : 128);
